import gql from 'graphql-tag';

export const checkoutPublicProduct = gql`
  mutation checkoutPublicProduct($input: CheckoutPublicProductInput!) {
    checkoutPublicProduct(input: $input) {
      success
      error
      transaction {
        id
        total_price
      }
    }
  }
`;

export const checkout = gql`
  mutation checkout($input: CheckoutInput!) {
    checkout(input: $input) {
      is_paid
      errors
      total_price {
        value
        currency
      }
      transaction {
        id
        total
      }
    }
  }
`;

export const accountPaymentMethodCreate = gql`
  mutation accountPaymentMethodCreate(
    $input: AccountPaymentMethodCreateInput!
  ) {
    accountPaymentMethodCreate(input: $input) {
      account_payment_method {
        id
      }
    }
  }
`;

export const searchSubscriptionCancel = gql`
  mutation searchSubscriptionCancel($input: SearchSubscriptionCancelInput!) {
    searchSubscriptionCancel(input: $input) {
      success
    }
  }
`;

export const searchSubscriptionRestore = gql`
  mutation searchSubscriptionRestore($input: SearchSubscriptionRestoreInput!) {
    searchSubscriptionRestore(input: $input) {
      success
    }
  }
`;

export const checkoutPhotoManagerSubscription = gql`
  mutation checkoutPhotoManagerSubscription(
    $input: CheckoutPhotoManagerSubscriptionInput!
  ) {
    checkoutPhotoManagerSubscription(input: $input) {
      success
    }
  }
`;

export const photoManagerSubscriptionCancel = gql`
  mutation photoManagerSubscriptionCancel(
    $input: PhotoManagerSubscriptionCancelInput!
  ) {
    photoManagerSubscriptionCancel(input: $input) {
      success
    }
  }
`;

export const photoManagerSubscriptionRestore = gql`
  mutation photoManagerSubscriptionRestore(
    $input: PhotoManagerSubscriptionRestoreInput!
  ) {
    photoManagerSubscriptionRestore(input: $input) {
      success
    }
  }
`;

export const checkoutPhotoFinderSubscription = gql`
  mutation checkoutPhotoFinderSubscription(
    $input: CheckoutPhotoFinderSubscriptionInput!
  ) {
    checkoutPhotoFinderSubscription(input: $input) {
      success
    }
  }
`;

export const photoFinderSubscriptionCancel = gql`
  mutation photoFinderSubscriptionCancel(
    $input: PhotoFinderSubscriptionCancelInput!
  ) {
    photoFinderSubscriptionCancel(input: $input) {
      success
    }
  }
`;

export const photoFinderSubscriptionRestore = gql`
  mutation photoFinderSubscriptionRestore(
    $input: PhotoFinderSubscriptionRestoreInput!
  ) {
    photoFinderSubscriptionRestore(input: $input) {
      success
    }
  }
`;

export const checkoutPhotoFinderCredits = gql`
  mutation checkoutPhotoFinderCredits(
    $input: CheckoutPhotoFinderCreditsInput!
  ) {
    checkoutPhotoFinderCredits(input: $input) {
      success
    }
  }
`;
